import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { Fragment, useState } from "react";
import { X } from "lucide-react";
import {
  PrimaryCTAButton,
  SecondaryCTAButton,
} from "../../components/CTAButtonComponents";
import {
  useGetAllCompanyFiles,
  useGetCompanyProcessedData,
} from "../../queries/onboarding";
import { FileExplorer, FileTree } from "./FileExplorer";
import Loader from "../../utils/loader";
import { ShareholderAGTable } from "./ShareholdersAGTable";
import { Shareholder } from "../../utils/stage3types";

type Props = {
  cin: string;
  showPopup: boolean;
  onClose: () => void;
  onSave: Function;
  selectedMgt7: string;
};

export const ShareholderDetailsPopup = ({
  showPopup,
  onClose,
  cin,
  onSave,
  selectedMgt7,
}: Props) => {
  const { data, isFetched } = useGetCompanyProcessedData(cin);

  return (
    <Transition show={showPopup} as={Fragment}>
      <Dialog as="div" className="relative z-10 w-[500px]" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="w-full h-[650px] mx-6 transform overflow-auto rounded-lg bg-white p-6 shadow-xl transition-all">
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <div className="">
                    <div>
                      {isFetched ? (
                        <ShareholderAGTable
                          onClose={onClose}
                          id={data?.id}
                          shareholdersData={
                            data?.shareholderData as Shareholder[]
                          }
                          cin={cin}
                          selectedMgt7={selectedMgt7 ?? ""}
                          loaUrl={data?.loaUrl ?? ""}
                        />
                      ) : (
                        <div className="h-[600px]">
                          <Loader />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
